export default __webpack_public_path__ + "static/media/android.d078bd62.svg";